import { toast } from 'sonner';
import { getApiErrorMessage } from '../../../utils/Support/supportHelpers';

/**
 * Mutation options for the ticket field editors (details pane and phone field strip). Failures are
 * toasted rather than held inline: a rejection that stays on screen after the rep fixes its cause
 * (e.g. sets the missing category) reads as a second, fresh failure.
 */
export const ticketMutationFeedback = (failMessage: string, onSuccess?: () => void) => ({
	onSuccess: () => onSuccess?.(),
	onError: (error: unknown) => toast.error(getApiErrorMessage(error, failMessage)),
});
